import { format } from "date-fns";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Box from "@mui/material/Box";
import DialogActions from "@mui/material/DialogActions";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Alert from "@mui/material/Alert";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useState } from "react";

import { useMessage } from "../../Message/MessageContext";
import { statusCancelamentoAgendamento } from "../../Agendamento/AgendamentoContext";

const motivos = Object.values(statusCancelamentoAgendamento);

export const RemoverPessoa = ({
  paciente,
  dataAgendamento,
  setorAtendimento,
  onClose,
}) => {
  const { setSuccess } = useMessage();
  const [localPaciente, setLocalPaciente] = useState(paciente);

  const showCheckbox =
    localPaciente.status === statusCancelamentoAgendamento.naoRealizado ||
    localPaciente.status ===
      statusCancelamentoAgendamento.pacienteNaoCompareceu;

  const onSubmit = async (e) => {
    e.preventDefault();
    setSuccess("Paciente removido com sucesso");
    onClose(localPaciente);
  };

  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Remover paciente do atendimento em grupo</DialogTitle>
      <form onSubmit={onSubmit}>
        <DialogContent>
          <Box mb={2}>
            <Alert severity="warning">
              Deseja realmente remover o paciente{" "}
              <strong>{localPaciente.nome}</strong> do atendimento em grupo de{" "}
              <strong>{format(dataAgendamento, "dd/MM/yyyy H:mm")} </strong>
              com o setor de <strong>{setorAtendimento.nome}</strong>?
            </Alert>
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Autocomplete
                options={motivos}
                value={
                  motivos.includes(localPaciente.status)
                    ? localPaciente.status
                    : ""
                }
                onChange={(e, status) =>
                  setLocalPaciente({ ...localPaciente, status })
                }
                fullWidth
                autoFocus
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Motivo"
                    variant="outlined"
                    required
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                fullWidth
                onChange={(e) =>
                  setLocalPaciente({
                    ...localPaciente,
                    descricao: e.target.value,
                  })
                }
                value={localPaciente.descricao || ""}
                label="Obs."
              />
            </Grid>
            {showCheckbox && (
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!localPaciente.ausenciaJustificada}
                      onChange={(e) =>
                        setLocalPaciente({
                          ...localPaciente,
                          ausenciaJustificada: e.target.checked || null,
                        })
                      }
                      value="remember"
                      color="primary"
                    />
                  }
                  label="Ausência justificada"
                />
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button type="submit" color="primary" variant="outlined">
            Confirmar
          </Button>
          <Button onClick={onClose}>Cancelar</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
